import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";


type Entity = models.ReporteVentaPPParametros;
export interface Props {
    value: Entity;
    puedeCambiarSucursal: boolean;
    onChange: (value: Entity) => PromiseLike<void>;
    onGenerar: () => Promise<void>;
}

/**
* Componente para editar un Entity
*/
class ReporteVentasPPNoRx extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    puedeCambiarSucursal = (x: Props) => x.puedeCambiarSucursal;

    get rules(): validation.Rules<Entity> {
        return {
        };
    }

    private onFechaDesdeChange = (x: Date | null) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(0, 0, 0, 0);
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroGuia> = { FechaInicio: fecha };
            const nuevo = { ...viejo, ...cambioFecha };
            this.props.onChange(nuevo);
        } else {
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroGuia> = { FechaInicio: null };
            const nuevo = { ...viejo, ...cambioFecha };
            this.props.onChange(nuevo);
        }
    }

    /**
    Establece la hora hasta a la ultima hora del día 11:59 pm
    */
    private onFechaHastaChange = (x: Date | null) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(23, 59, 59);
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroGuia> = { FechaFinal: fecha };
            const nuevo = { ...viejo, ...cambioFecha };
            this.props.onChange(nuevo);
        } else {
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroGuia> = { FechaFinal: null };
            const nuevo = { ...viejo, ...cambioFecha };
            this.props.onChange(nuevo);
        }
    }

    render() {
        const { value, onGenerar } = this.props;
        const getField = this.getField;
        const puedeCambiarSucursal = this.puedeCambiarSucursal(this.props);
        const DateTime = getField(kea.DateTime);
        const Number = getField(kea.Number);
        const Sucursal = getField(selectores.Sucursal);
        return (
            <div>
                <kea.Title titulo="Reporte de venta de guías de PP" onRegresar={() => history.go("../")} />
                {kea.autogrid(6, [
                    <Sucursal field="IdSucursal" label="Sucursal:" readonly={!puedeCambiarSucursal} />,
                ])}
                {kea.autogrid(6, [
                    <DateTime field="FechaInicio" label="Fecha inicio:" onChange={this.onFechaDesdeChange} />,
                    <DateTime field="FechaFinal" label="Fecha final:" onChange={this.onFechaHastaChange} />,
                ])}
                <div className="row">
                    <div className="col-md-12">
                        <kea.Button children="Generar reporte" style="success" onClick={onGenerar} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>);
    }
}

export const ReporteVentasPPForm = componentToRx(ReporteVentasPPNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/reporteventapp/form.tsx